import { render } from "./Header.vue?vue&type=template&id=da34d610&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=da34d610&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2216102391/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da34d610"]])

export default __exports__